import type { StorageArea, StorageKeyMove } from '@core/models/storage.model';
import {
  OLD_TOUR_COMPLETED_PREFIX,
  SESSION_STORAGE_KEY_MOVES,
  STORAGE_KEY_MOVES,
  STORAGE_KEYS,
} from '@core/constants/storage-keys.constants';
import {
  readWebStorage,
  removeWebStorage,
  webStorageKeys,
  writeWebStorage,
} from '@core/utils/web-storage.utils';

/** Moves one value to its new key and area. An old key still present wins: only old code wrote it. */
function moveKey(fromArea: StorageArea, move: StorageKeyMove): void {
  const value = readWebStorage(fromArea, move.from);
  if (value === null) return;
  writeWebStorage(move.area, move.to, value);
  removeWebStorage(fromArea, move.from);
}

/**
 * Moves the values stored under the keys used before 19 Oct 2026 to today's keys, and the user's
 * data (profile, tenant, permissions, recent leads, project context) out of `localStorage` into
 * this tab's `sessionStorage`. Runs before anything reads storage; once moved there is nothing
 * left to do, so later boots only look up a dozen missing keys.
 */
export function migrateStorageKeys(): void {
  for (const move of STORAGE_KEY_MOVES) moveKey('local', move);
  for (const move of SESSION_STORAGE_KEY_MOVES) moveKey('session', move);
  for (const key of webStorageKeys('local')) {
    if (!key.startsWith(OLD_TOUR_COMPLETED_PREFIX)) continue;
    const tourId = key.slice(OLD_TOUR_COMPLETED_PREFIX.length);
    moveKey('local', { from: key, to: STORAGE_KEYS.tourCompletedPrefix + tourId, area: 'local' });
  }
}
